export const AuthRouteName = {
  Login: 'auth.login',
  Register: 'auth.register',
  ForgotPassword: 'auth.forgot-password',
  ResetPassword: 'auth.reset-password',
  PasswordChangedSuccess: 'auth.password-changed-success',
  VerifyEmail: 'auth.verify-email',
  CheckMail: 'auth.check-mail',
  EmailChanged: 'auth.email-changed',
} as const;

export const AccountRouteName = {
  Dashboard: 'account.dashboard',
  Library: 'account.library',
  LibraryDocument: 'account.library.document',
  Downloads: 'account.downloads',
  Profile: 'account.profile',
  AdminDocumentCreate: 'account.admin.documents.create',
  AdminDocumentEdit: 'account.admin.documents.edit',
} as const;
